<template>
  <section>
    <div class="container wfs--main">
      <div class="row">
        <div class="col-md-12 bread">
          <ol class="bread-crumb breadcrumb-fill0">
            <li>
              <router-link to="/home">home</router-link>
            </li>
            <li>
              <a href="javascript:void(0);" class="bread-text">CIDADÃO REGISTRO</a>
            </li>
          </ol>
        </div>

        <div class="col-md-12"  style="padding-left: 0px;padding-right: 0px;">
          <div
            class="card"
            style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 20px !important;"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">Usuario {{dados_recebidos.nome}} Cadastrado com Sucesso!</div>
              </div>
            </div>
          </div>
        </div>

        <card class="col-md-12">
          <h4>Nome: {{dados_recebidos.nome}}</h4>
          <h4>Email: {{dados_recebidos.email}}</h4>
          <div v-if="dados_recebidos.cpf">
            <h4 v-if="dados_recebidos.cpf.length ==11">
              CPF:
              {{dados_recebidos.cpf[0]+dados_recebidos.cpf[1]+dados_recebidos.cpf[2]+"."+dados_recebidos.cpf[3]+dados_recebidos.cpf[4]+dados_recebidos.cpf[5]+"."+
              dados_recebidos.cpf[6]+dados_recebidos.cpf[7]+dados_recebidos.cpf[8]+"-"+dados_recebidos.cpf[9]+dados_recebidos.cpf[10]}}
            </h4>
            <h4 v-if="dados_recebidos.cpf.length ==10">
              CPF:
              {{dados_recebidos.cpf[0]+dados_recebidos.cpf[1]+dados_recebidos.cpf[2]+"."+dados_recebidos.cpf[3]+dados_recebidos.cpf[4]+dados_recebidos.cpf[5]+"."+
              dados_recebidos.cpf[6]+dados_recebidos.cpf[7]+dados_recebidos.cpf[8]+"-"+dados_recebidos.cpf[9]}}
            </h4>
          </div>
          <h4 v-if="dados_recebidos.cnpj">
            CNPJ:
            {{dados_recebidos.cnpj[0]+dados_recebidos.cnpj[1]+"."+dados_recebidos.cnpj[2]+dados_recebidos.cnpj[3]+dados_recebidos.cnpj[4]+"."+dados_recebidos.cnpj[5]+dados_recebidos.cnpj[6]+dados_recebidos.cnpj[7]+"/"+
            dados_recebidos.cnpj[8]+dados_recebidos.cnpj[9]+dados_recebidos.cnpj[10]+dados_recebidos.cnpj[11]+"-"+dados_recebidos.cnpj[12]+dados_recebidos.cnpj[13]}}
          </h4>

          <h4>
            Endereço: 
              <b v-if="dados_recebidos.rua" >{{dados_recebidos.rua}} </b> <b v-else> sem rua </b>
              <b v-if="dados_recebidos.numero" > - {{dados_recebidos.numero}} </b> <b v-else> - sem numero</b>
              <b v-if="dados_recebidos.complemento" > - {{dados_recebidos.complemento}} </b> <b v-else> - sem complemento</b>
              <b v-if="dados_recebidos.bairro" > - {{dados_recebidos.bairro}} </b> <b v-else> - sem bairro</b>
              <b v-if="dados_recebidos.cidade" > - {{dados_recebidos.cidade}} </b> <b v-else> - sem cidade</b>
              <b v-if="dados_recebidos.estado" > - {{dados_recebidos.estado}} </b> <b v-else> - sem estado</b>
              <b v-if="dados_recebidos.cep" > - {{dados_recebidos.cep}} </b> <b v-else> - sem cep</b>
          </h4>
          

          <h4 v-if="dados_recebidos.telefone != null">
            Telefone:
            {{"("+dados_recebidos.telefone[0]+dados_recebidos.telefone[1]+")"+dados_recebidos.telefone[2]
            +dados_recebidos.telefone[3] +dados_recebidos.telefone[4]+dados_recebidos.telefone[5]+"-"+
            dados_recebidos.telefone[6]+dados_recebidos.telefone[7]+dados_recebidos.telefone[8]+
            dados_recebidos.telefone[9]}}
          </h4>

          <h4 v-if="dados_recebidos.celular != null">
            Celular:
            {{"("+dados_recebidos.celular[0]+dados_recebidos.celular[1]+")"+dados_recebidos.celular[2]
            +dados_recebidos.celular[3] +dados_recebidos.celular[4]+dados_recebidos.celular[5]+
            dados_recebidos.celular[6]+"-"+dados_recebidos.celular[7]+dados_recebidos.celular[8]+
            dados_recebidos.celular[9]+dados_recebidos.celular[10]}}
          </h4>

        
          <div class="clearfix"></div>
          <router-link to="login" class="btn btn-primary btn-fill">Ir ao login</router-link>
        </card>
      </div>
    </div> 
  </section>   
</template>
<script>
// import { required, minLength, maxLength, between} from 'vuelidate/lib/validators'
import Card from "src/components/Cards/Card.vue";
import axios from "axios";
import store from "src/store.js";
import "src/controller/site/cidadaoController.js";

export default {
  components: {
    Card,
  },
  props: {
    dados_recebidos: {
      require: true,
    },
  },
  data() {
    return {};
  },

  methods: {},
  beforeMount() {
    console.log(this.dados_recebidos);
  },
};
</script>
<style>
ol {
  list-style: none;
}
.bread {
  padding-right: 0px;
  padding-left: 0px;
}
.bread-crumb {
  width: 100%;
  float: left;
  margin: 0px 0px 20px 0;
  position: relative;
  display: block;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}
.breadcrumb-fill0 {
  padding: 10px;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 0 40px -10px rgba(0, 0, 0, 0.25);
}
.bread-crumb li {
  height: auto;
  line-height: 30px;
  float: left;
  padding: 0 12px;
}
.bread-text,
.bread-text:hover {
  color: black;
}
</style>
